import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { toast } from "react-toastify";
import SourcesList from "./SourcesList";
import AddEditSource from "./AddEditSource";
import { addSource } from "services/sourcesService";

const Sources = (props) => {
  const [addnewform, setaddnewform] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const closeForm = () => {
    setaddnewform(false);
  };

  React.useEffect(() => {
    if (props.onClose === false) {
      closeForm();
    }
  }, [props.onClose]);

  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const postingData = {
        ...data,
        active: data.active ?? true,
        sourceType: "Matter",
      };
      const result = await addSource(postingData);
      if (result.success) {
        toast.success("Source Added Successfully");
        setaddnewform(false);
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn`}
          onClick={() => setaddnewform(true)}
        >
          Add <br />
          Source
        </Button>
      </div>

      <div className="flex-grow-1 settings-grid-wrapper mb-2" style={{ minHeight: 0 }}>
        <SourcesList />
      </div>

      {addnewform && (
        <AddEditSource
          cancelEdit={closeForm}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default Sources;
